import { useRouter } from "next/router";
import { Fortune, TelFortune } from "shared/types";
import { Paths } from "utils/routes";

interface UseNavigationReturn {
  goToFortuneTeller: () => void;
  goToReviews: () => void;
  goToCategory: () => void;
}

const useNavigation = (menu: Fortune | TelFortune): UseNavigationReturn => {
  const { push } = useRouter();

  const isChatMenu = menu?.type === "chat";

  const goToFortuneTeller = async () => {
    await push(Paths.fortuneTellers.show(menu?.fortuneTeller.id));
  };
  const goToReviews = async () => {
    isChatMenu
      ? await push(Paths.fortunes.reviews(menu?.id))
      : await push(Paths.telFortunes.reviews(menu?.id));
  };
  const goToCategory = async () =>
    await push(Paths.categories.index(menu?.category.alias));

  return {
    goToFortuneTeller,
    goToReviews,
    goToCategory,
  };
};

export default useNavigation;
